export default __webpack_public_path__ + "static/media/dart.30bf58d8.svg";